import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { UserProfileEffects } from './user-profile.effects';
import { initialState, reducer } from './user-profile.reducer';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('userProfile', reducer, { initialState }), EffectsModule.forFeature([UserProfileEffects])],
  providers: [UserProfileEffects],
})
export class UserProfileStoreModule {}
